/*
 * @Author: LUOHM
 * @Date: 2022-05-11 11:09:41
 * @LastEditTime: 2022-06-01 15:05:29
 * @LastEditors: LUOHM
 */

const getLocale=()=>{
  const fullLang = navigator.language.toLocaleLowerCase()
  const [preLang, endLang] = fullLang.split("-")
  const  lang = preLang.substr(0, 2)
  let locale;
  switch (lang) {
    case "zh":
      locale = (!endLang || endLang === 'cn') ?  'cn' : 'tw'
      break;
    case "en":
      locale = 'en';
      break;
    case "ja":
      locale = 'ja';
      break;
    case "ko":
      locale = 'ko';
      break;
    case "vi":
      locale = 'vi';
      break;
    case "th":
      locale = 'th';
      break;
    case "es":
      locale = 'es';
      break;
    case "pt":
      locale = 'pt';
      break;
    case "id":
      locale = 'id';
      break;
    default:
      locale = 'en';
      break;
  }
  return locale
}

export default {
  getLocale
}
